import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Alert } from '../models/alert.model';

@Injectable()
export class AlertService {
  private subject = new BehaviorSubject<Alert>(null);
  private defaultId = 'default-alert';

  onAlert(id = this.defaultId): Observable<Alert> {
    return this.subject.asObservable().pipe(filter(x => x && x.id === id));
  }

  success(message: string, options?: any) {
    this.alert(new Alert({ ...options, alertType: 'success', message }));
  }

  error(message: string, options?: any) {
    this.alert(new Alert({ ...options, alertType: 'error', message }));
  }

  info(message: string, options?: any) {
    this.alert(new Alert({ ...options, alertType: 'info', message }));
  }

  warn(message: string, options?: any) {
    this.alert(new Alert({ ...options, alertType: 'warning', message }));
  }

  alert(alert: Alert) {
    alert.id = alert.id || this.defaultId;
    this.subject.next(alert);
  }

  clear(id = this.defaultId) {
    this.subject.next(new Alert({ id }));
  }
}
